import { render, staticRenderFns } from "./content.vue?vue&type=template&id=0dfcb09b&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=0dfcb09b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfcb09b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfcb09b')) {
      api.createRecord('0dfcb09b', component.options)
    } else {
      api.reload('0dfcb09b', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=0dfcb09b&scoped=true", function () {
      api.rerender('0dfcb09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/content.vue"
export default component.exports